import { Controller } from "@hotwired/stimulus"

// RichiestaForm di pages/Piani.js: «Quante» per pratiche e utenti, «Piano» per cambio e rinnovo, con la prima voce
// «Lo stesso» (rinnovo) o «Scegli…» (cambio). I campi nascosti restano nel form e si inviano, come lo stato `f`.
export default class extends Controller {
  static targets = ["tipo", "quante", "piano", "vuota"]

  connect() {
    this.cambia()
  }

  cambia() {
    const tipo = this.tipoTarget.value
    this.quanteTarget.hidden = !(tipo === "pratiche" || tipo === "utenti")
    this.pianoTarget.hidden = !(tipo === "cambio" || tipo === "rinnova")
    this.vuotaTarget.textContent = tipo === "rinnova" ? "Lo stesso" : "Scegli…"
  }
}
